
export enum NewsItemType {
    TEXT = "TEXT",
    HTML = "HTML",
    DOCUMENT = "DOCUMENT"
}
